module.exports = __webpack_public_path__ + "static/media/slide1.7263455c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/slide1.png
// module id = 255
// module chunks = 0